<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="广告标题" prop="title">
                <a-input v-model="queryParam.title" placeholder="请输入广告标题" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <template v-if="advanced">-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="是否首页弹框展示" prop="isDisplay">-->
<!--                  <a-input v-model="queryParam.isDisplay" placeholder="请输入是否首页弹框展示" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--            </template>-->
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd" v-hasPermi="['index:banner:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="handleUpdate" v-hasPermi="['index:banner:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleBatchDelete" v-hasPermi="['index:banner:remove']">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['index:banner:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <!-- <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" /> -->
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        :rowKey="record => record.id || record.key || Math.random()"
        :scroll="{x: 1500,y:'calc(100vh - 300px)'}"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :locale="{ emptyText: '暂无数据' }"
      >
      <span slot="index" slot-scope="text, record,index">
          {{(current-1)*size+index+1}} 
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="image" slot-scope="text, record">
           <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="record.image"
                :src="record.image" preview="头像"/>
        </span>
        <span slot="operation" slot-scope="text, record, index">
          <a-divider type="vertical" v-hasPermi="['index:banner:edit']" />
          <a @click="handleEdit(record)" v-hasPermi="['index:banner:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['index:banner:remove']" />
          <a @click="handleDelete(record, index)" v-hasPermi="['index:banner:remove']">
            <a-icon type="delete" :style="{ color: 'red' }" />
            <span class="text-red">删除</span>
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageBanner,listBanner, delBanner } from '@/api/index/banner'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Banner',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
     //索引indexs
      indexs: [], 
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        title: null,
        image: null,
        isDisplay: null,
        type: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,                    
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        // {
        //   title: '广告编号',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '广告标题',
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
 
        {
          title: '广告图片',
          dataIndex: 'image',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'image'}
        },
        {
          title: '是否首页弹框展示',
          dataIndex: 'isDisplay',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f ==1){
              return '是'
            }else{
              return '否'
            }
          }
        },
        {
          title: '类型 ',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f ==1){
              return '新人广告'
            }else if(f==2){
              return '弹出框广告'
            }else{
              return '商城轮播图'
            }
          }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '跳转地址',
        //   dataIndex: 'url',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    console.log('Banner 组件 created 生命周期触发')
    console.log('当前路由:', this.$route)
    // 初始化时获取列表
    this.getList()
  },
  mounted () {
    console.log('Banner 组件 mounted 生命周期触发')
    console.log('组件数据状态:', {
      listLength: this.list.length,
      loading: this.loading,
      total: this.total
    })
    // 确保组件挂载后数据正确显示
    if (this.list.length === 0 && !this.loading) {
      console.warn('组件挂载完成，但数据为空且未在加载中，可能存在问题')
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询广告信息列表 */
    getList () {
      this.loading = true
      // 清理查询参数中的null值，避免发送不必要的参数
      const params = {}
      Object.keys(this.queryParam).forEach(key => {
        if (this.queryParam[key] !== null && this.queryParam[key] !== undefined && this.queryParam[key] !== '') {
          params[key] = this.queryParam[key]
        }
      })
      // 确保分页参数存在
      params.pageNum = this.queryParam.pageNum || 1
      params.pageSize = this.queryParam.pageSize || 10
      
      console.log('请求参数:', params)
      
      pageBanner(params)
        .then((response) => {
          console.log('API响应:', response)
          
          // 处理不同的响应数据结构
          let pageData = null
          if (response) {
            // 如果响应直接是分页数据
            if (response.records && Array.isArray(response.records)) {
              pageData = response
            }
            // 如果响应在 data 中
            else if (response.data) {
              // 如果 data 直接是分页数据
              if (response.data.records && Array.isArray(response.data.records)) {
                pageData = response.data
              }
              // 如果 data 中还有 data（双重包装）
              else if (response.data.data && response.data.data.records && Array.isArray(response.data.data.records)) {
                pageData = response.data.data
              }
            }
          }
          
          if (pageData) {
            this.list = pageData.records || []
            this.total = pageData.total || 0
            this.current = pageData.current || 1
            this.size = pageData.size || 10
            console.log('数据加载成功:', {
              list: this.list.length,
              total: this.total,
              current: this.current,
              size: this.size
            })
          } else {
            console.warn('响应数据格式异常:', response)
            this.list = []
            this.total = 0
            this.current = 1
            this.size = 10
            this.$message.warning('数据格式异常，请检查接口返回')
          }
          this.loading = false
        })
        .catch((error) => {
          console.error('获取广告列表失败:', error)
          console.error('错误详情:', {
            message: error.message,
            response: error.response,
            stack: error.stack
          })
          
          let errorMsg = '获取广告列表失败，请稍后重试'
          if (error.response) {
            if (error.response.status === 403) {
              errorMsg = '没有权限访问该接口'
            } else if (error.response.status === 404) {
              errorMsg = '接口不存在，请检查API地址'
            } else if (error.response.data && error.response.data.message) {
              errorMsg = error.response.data.message
            }
          } else if (error.message) {
            errorMsg = error.message
          }
          
          this.$message.error(errorMsg)
          this.loading = false
          this.list = []
          this.total = 0
        })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        title: undefined,
        image: undefined,
        isDisplay: undefined,
        type: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
        // 列表顶部删除indexs
        if(this.selectedRowKeys.length){
        const indexList = this.selectedRowKeys.map(item=>{
          return this.list.findIndex(i=>i.id === item)
        })
        this.indexs = indexList.filter(item=>item!==-1).map(ind=>{
          return (this.current - 1) * this.size + ind + 1
        })
      }
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 新增按钮操作 */
    handleAdd () {
      if (this.$refs.createForm) {
        this.$refs.createForm.handleAdd()
      } else {
        this.$message.warning('表单组件未初始化')
      }
    },
    /** 修改按钮操作 */
    handleUpdate () {
      if (this.$refs.createForm) {
        this.$refs.createForm.handleUpdate(undefined, this.ids)
      } else {
        this.$message.warning('表单组件未初始化')
      }
    },
    /** 编辑按钮操作 */
    handleEdit (record) {
      if (this.$refs.createForm) {
        this.$refs.createForm.handleUpdate(record, undefined)
      } else {
        this.$message.warning('表单组件未初始化')
      }
    },
    /** 批量删除按钮操作 */
    handleBatchDelete () {
      if (this.ids.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.handleDelete(null, null)
    },
    /** 删除按钮操作 */
    handleDelete(row,index) {
      var that = this
      const ids = row.id || this.ids
      const inds = (this.current - 1) * this.size + index + 1   
      const indexs = inds || this.indexs.sort((a, b) => a - b)
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中序号为' + indexs + '的数据',
        onOk() {
          let data = []
          if(row.id){
                data.push({"id":row.id})
              }else {
                that.ids.map(id => data.push({"id":id}))
              }
          return delBanner(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('删除成功', 3)
            })
            .catch((error) => {
              console.error('删除失败:', error)
              that.$message.error('删除失败，请稍后重试')
            })
        },
        onCancel () {
          //取消清空删除ids列表
          // that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('index/banner/export', {
            ...that.queryParam
          }, `广告信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
